import { useMutation, useQuery } from '@tanstack/react-query';
import { createInsuranceCarrierConfiguration, deleteInsuranceCarrierConfiguration, getInsuranceCarrierConfigurations, updateInsuranceCarrierConfiguration } from '@features/insuranceCarriers/services/insuranceCarrierConfigurationsService';

const BASE = 'insurance-carrier-configurations';

export const insuranceCarrierConfigurationsQueryKeys = {
  base: () => [BASE],
  list: ({ insuranceCarrierId, filters }) => [BASE, 'list', insuranceCarrierId, filters],
};

export const useGetInsuranceCarrierConfigurations = ({ insuranceCarrierId, filters }, { enabled = true } = {}) => {
  return useQuery({
    queryKey: insuranceCarrierConfigurationsQueryKeys.list({ insuranceCarrierId, filters }),
    queryFn: () => getInsuranceCarrierConfigurations(insuranceCarrierId, filters),
    enabled: enabled && !!insuranceCarrierId,
    gcTime: 0, // No conservar datos en caché al cerrar el modal — cada apertura carga datos frescos
  });
};

export const useCreateInsuranceCarrierConfiguration = () => {
  return useMutation({
    mutationFn: ({ insuranceCarrierId, data }) => createInsuranceCarrierConfiguration(insuranceCarrierId, data),
  });
};

export const useUpdateInsuranceCarrierConfiguration = () => {
  return useMutation({
    mutationFn: ({ insuranceCarrierId, configurationId, data }) => updateInsuranceCarrierConfiguration(insuranceCarrierId, configurationId, data),
  });
};

export const useDeleteInsuranceCarrierConfiguration = () => {
  return useMutation({
    mutationFn: ({ insuranceCarrierId, configurationId }) => deleteInsuranceCarrierConfiguration(insuranceCarrierId, configurationId),
  });
};
